import Vue from "vue";

export default {
  set(state, data) {
    state.data = data;
  },
  update(state, tenant) {
    let i = state.data.findIndex(x => x.id === tenant.id);
    if (i > -1) Vue.set(state.data, i, tenant);
    else state.data.push(tenant);
  }
};
